// noinspection JSUnresolvedVariable
export const ZT_ROOT_ADDRESS = DEPLOY_ENV === 'master' ? '//ws.xoyo.com' : '//test-ws.xoyo.com';

// noinspection JSUnresolvedVariable
export const PASSPORT_ROOT_ADDRESS = DEPLOY_ENV === 'master' ? '//pf-api.xoyo.com/passport/common_api' : '//my-api-dev.xoyo.com/passport/common_api';

// noinspection JSUnresolvedVariable
// (通行证登录)
export const CAPTCHA_PRE_AUTH =
  DEPLOY_ENV === 'master' ? '//pf-api.xoyo.com/passport/common_api/pre_auth' : '//my-api-dev.xoyo.com/passport/common_api/pre_auth';

// noinspection JSUnresolvedVariable
// (专题，用于获取短信验证)
export const CAPTCHA_ZT_AUTH = DEPLOY_ENV === 'master' ? '//ws.xoyo.com/core/captcha/pre_auth' : '//test-ws.xoyo.com/core/captcha/pre_auth';

// noinspection JSUnresolvedVariable
export const XOYO_AUTH_URL = DEPLOY_ENV === 'master' ? '//m.xoyo.com' : '//m-dev.xoyo.com';

// 登录组件接口
export const ANTIQUEACCOUNT_URL = DEPLOY_ENV === 'master' ? '//pf-api.xoyo.com/' : '//my-api-dev.xoyo.com/';

// 拼接跳转移动端页面
export const SHARE_URL =
  DEPLOY_ENV === 'master'
    ? 'https://jxsj.xoyo.com/m/2019/07/08/antique/index.html?utme_souce=qrcode/#/'
    : 'https://test-zt.xoyo.com/jxsj.xoyo.com/m/2019/07/08/antique/index.html?utme_souce=qrcode/#/';



// WEBPACK FOOTER //
// ./src/constants/urls.js